import React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import isBefore from 'date-fns/isBefore'
import defaultAvatar from '../img/medium.png'

const NO_IMAGE = 'avatar/athlete/medium.png'

const METERS_TO_MILES = 0.0006213712
const METERS_TO_FEET = 3.280839935991

const sortFns = {
  distance: (a, b) => b.summary.distance - a.summary.distance,
  elevation: (a, b) => b.summary.elevation - a.summary.elevation,
  elapsed: (a, b) => b.summary.elapsedTime - a.summary.elapsedTime,
  moving: (a, b) => b.summary.movingTime - a.summary.movingTime,
}

const GET_LEADERBOARD = gql`
  query Leaderboard($id: String!) {
    competitorsInChallenge(challenge: $id, _size:500) {
      data {
        athleteId
        info {
          firstName
          lastName
          city
          state
          profilePic
        }
        summary {
          distance
          elevation
          elapsedTime
          movingTime
        }
        activitiesCount
      }
    }
  }
`

export const Leaderboard = ({challenge}) => {
  console.log(challenge)
  const [ sort, setSort ] = useState('distance')
  const sortFn = sortFns[sort]
  const convert = challenge.units === "miles"
  const notStarted = isBefore(Date.now(), new Date(challenge.startdate))

  console.log('Loading leaderboard')
  const { error, data: leaderboard } = useQuery(GET_LEADERBOARD, {
    variables: { id: challenge.id },
    skip: notStarted,
    ssr: false
  });
  console.log(`Error leading the leaderboard: ${error}`)
  console.log(leaderboard)

  let data = []
  if(leaderboard) 
    data = leaderboard.competitorsInChallenge.data

  const getDuration = (seconds) => {
    var measuredTime = new Date(null)
    measuredTime.setSeconds(seconds)
    return measuredTime.toISOString().substr(11, 8);
  }

  const distanceUnits = convert ? 'mi' : 'km'
  const elevationUnits = convert ? 'ft' : 'm'
  const convertDistance = (distance) => {
    const val = convert ? distance * METERS_TO_MILES : distance
    return val.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits:1 })
  }
  const convertElevation = (elevation) => {
    const val = convert ? elevation * METERS_TO_FEET : elevation
    return val.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits:1 })
  }

  const indicateSort = (value) => {
    return value === sort ? String.fromCharCode(9660) : ""
  }

  return (
    <div>
      <table className="table is-striped is-hoverable">
        <thead>
          <tr>
            <th><abbr title="Position">#</abbr></th>
            <th></th>
            <th>Name</th>
            <th>Runs</th>
            <th><a title="Sort by Distance" onClick={() => setSort("distance")}>Distance</a>{indicateSort("distance")}</th>
            <th><a title="Sort by Elevation" onClick={() => setSort("elevation")}>Elevation</a>{indicateSort("elevation")}</th>
            <th><a title="Sort by Elapsed Time" onClick={() => setSort("elapsed")}>Elapsed Time</a>{indicateSort("elapsed")}</th>
            <th><a title="Sort by Moving Time" onClick={() => setSort("moving")}>Moving Time</a>{indicateSort("moving")}</th>
          </tr>
        </thead>
        <tbody>
        { 
          data.sort(sortFn).map((competitor, i) => (
            <tr key={i}>
              <th>{ `${++i}`}</th>
              <td>
                <figure className="image is-32x32">
                  <img className=" is-rounded" src={competitor.info.profilePic === NO_IMAGE ? defaultAvatar : competitor.info.profilePic} atl={`Profile picture for ${competitor.info.firstName}`}/>
                </figure>
              </td>
              <td>
                <a href={`https://www.strava.com/athletes/${competitor.athleteId}`} target="_blank" rel="noopener noreferrer">
                  { `${competitor.info.firstName} ${competitor.info.lastName}` }
                </a>
              </td>
              <td>{competitor.activitiesCount}</td>
              <td>{ convertDistance(competitor.summary.distance) } <span className="is-small">{distanceUnits}</span></td>
              <td>{ convertElevation(competitor.summary.elevation) } <span className="is-small">{elevationUnits}</span></td>
              <td>{ getDuration(competitor.summary.elapsedTime) }</td>
              <td>{ getDuration(competitor.summary.movingTime) }</td>
            </tr>
          )) 
        }
        </tbody>
      </table>
      { notStarted && (<h4>Challenge has not started yet</h4>)}
    </div>
  )
}

Leaderboard.propTypes = {
  challenge: PropTypes.object,
}

export default Leaderboard